<div class="page-detail-container">
  <div class="detail-header">
    <button mat-icon-button (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="header-title">Page Details</span>
  </div>

  <div class="detail-content">
    <div class="thumbnail-section">
      <div class="large-thumbnail" [style.aspect-ratio]="getThumbnailAspectRatio()">
        <img [src]="page.thumbnail" [alt]="page.name" width="100%" />
      </div>
    </div>

    <div class="metadata-section">
      <h3 class="page-name">{{ page.name }}</h3>
      <p class="page-section" *ngIf="page.section_name">{{ page.section_name }}</p>
      <p class="page-description" *ngIf="page.description">{{ page.description }}</p>

      <div class="action-buttons" align="start">
        <button mat-raised-button color="primary" (click)="onInsert()" class="insert-button">Select page</button>
        <button mat-button (click)="onBack()">Back</button>
      </div>
    </div>
  </div>
</div>
